import modal from './Modal';

export default function header() {
  document.addEventListener('DOMContentLoaded', () => {
    const elAutohide = document.getElementById('header') as HTMLElement;
    const mainWrapper = document.getElementById('wrapper') as HTMLElement;

    if (elAutohide) {
      let lastScrollTip = 0;
      window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY;
        if (scrollTop === 0) {
          elAutohide.classList.add('scrolled-top');
          elAutohide.classList.remove('scrolled-down', 'scrolled-up');

          mainWrapper.classList.add('scrolled-top');
          mainWrapper.classList.remove('scrolled-down', 'scrolled-up');
        } else if (scrollTop < lastScrollTip) {
          elAutohide.classList.remove('scrolled-top', 'scrolled-down');
          elAutohide.classList.add('scrolled-up');

          mainWrapper.classList.remove('scrolled-top', 'scrolled-down');
          mainWrapper.classList.add('scrolled-up');
        } else {
          elAutohide.classList.remove('scrolled-top', 'scrolled-up');
          elAutohide.classList.add('scrolled-down');

          mainWrapper.classList.remove('scrolled-top', 'scrolled-up');
          mainWrapper.classList.add('scrolled-down');
        }
        lastScrollTip = scrollTop;
      });
    }
  });

  return {
    openDropdown: new Map<number, boolean>(),
    openAccount: false,
    openLanguage: false,
    toggleMenuSectionOpen(key: number) {
      this.openDropdown.set(key, this.openDropdown.has(key) ? !this.openDropdown.get(key) : true);
    },
    mainMenuSectionOpen(key: number) {
      return this.openDropdown.has(key) && this.openDropdown.get(key);
    },
    toggleLanguageOpen() {
      this.openLanguage = !this.openLanguage;
    },
    toggleAccountOpen() {
      this.openAccount = !this.openAccount;
    },
    ...modal(),
  };
}
